import { render, staticRenderFns } from "./DispensaMarcaModelo.vue?vue&type=template&id=6adb9c61&"
import script from "./DispensaMarcaModelo.vue?vue&type=script&lang=js&"
export * from "./DispensaMarcaModelo.vue?vue&type=script&lang=js&"
import style0 from "./DispensaMarcaModelo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports